<div class="grid-container margin-top">
    <div class="grid-x margin-top">
        <div class="cell small-12">
            <iframe width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=bd4ed27d-69f7-4e43-a39b-a204b501ae57&autoAuth=true&ctid=eb5bb4f9-ca67-467a-85b5-42d23ee13edb&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLWVhc3QyLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9" frameborder="0" allowFullScreen="true"></iframe>
        </div>
    </div>
</div>

